import { AxiosPostType } from '../../../context/FetchProvider';

export type ScheduleOptions = {
  flagged?: boolean;
};

/**
 * Reschedule a quiz item's spaced repetition value.
 */
export const reschedule = async (
  post: AxiosPostType,
  nodeID: number,
  days: number,
) =>
  post('/mobileRescheduleQues', {
    nodeID,
    days,
  });

/**
 * Add an item to the spaced repetition queue.
 */
export const schedule = (
  post: AxiosPostType,
  nodeIDs: number[],
  options?: ScheduleOptions,
) =>
  post('/scheduleForReview', {
    nodeIDs,
    local: 0,
    ...(options?.flagged ? { unflag: 'unflag' } : {}),
  });

/**
 * Set the flagged value for a quiz item.
 */
export const setFlagged = (
  post: AxiosPostType,
  nodeIDs: number[],
  flagged: boolean,
) => schedule(post, nodeIDs, { flagged });
